import React from 'react';
import { InputNameDialog } from "components";
import { useNotify, useCreateTemplateFromSite } from 'hooks';
import { getFromLocalStorage } from 'utils';
import { AxiosError } from 'axios';
import { SELECTED_SITE_LOCAL_STORAGE_KEY } from '../../../../../consts';

interface SaveAsTemplateProps {
    isOpen: boolean;
    onClose: () => void;
}

export const SaveAsTemplate: React.FC<SaveAsTemplateProps> = ({
    isOpen,
    onClose,
}) => {
    const notify = useNotify();
    const createTemplateFromSite = useCreateTemplateFromSite();
    const { id: siteId } = getFromLocalStorage(SELECTED_SITE_LOCAL_STORAGE_KEY) || { id: 0 };

    const handleCreateTemplate = (templateName: string) => {
        createTemplateFromSite.mutate({
            siteId,
            data: { templateName }
        }, {
            onSuccess: () => {
                notify.success('Template created successfully');
                onClose();
            },
            onError: (error: Error) => {
                const axiosError = error as AxiosError;
                notify.error(typeof axiosError?.response?.data === 'string' ? axiosError.response.data : `Failed to create template: ${error.message}`);
            }
        });
    };

    return (
        <InputNameDialog
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={handleCreateTemplate}
            isLoading={createTemplateFromSite.isLoading}
            mainTitle="Save Card as Template"
            placeholder="Enter template name"
            label="Template Name"
        />
    );
};
